import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import { Tooltip } from "devextreme-react/ui/tooltip";

import DataSource from "devextreme/data/data_source";
import DataGrid, { Column, Paging, Pager, RemoteOperations, MasterDetail } from "devextreme-react/ui/data-grid";
import LoadingGif from "../../../../../images/animacion2[18].gif";

import { getPrestacionesApi } from "../../../../../services/PrestacionesEconomicasApi";
import { doGetDocumentBySiniestro } from "../../../Documentos/actions";
import HeaderTooltip from "../../../../Shared/headerTooltip";
import { openCloseToast } from "../../../../Global/actions";
import { setPrestaciones } from "./actions";
import TableFilter from "../../../../Shared/tableFilter.jsx";
import { getFiltros, filterData, filterType } from "../../../../../helpers/filterHelper";
import NoDataComponent from "../../../../Shared/noDataImage";
import Documentos from "../../../Documentos/modalDocumentos";

const EmptyIcon = (props) =>
  (<div
    className={`siniestro-empresa-reposo ${props.full ? "active" : ""}`}
    style={{
      height: props.size,
      width: props.size,
      borderRadius: props.border,
    }}
  />);

const TableDetails = (props) => (
  <div style={{ textAlign: "left" }}>
    <span style={{ fontSize: 18 }}>
      Periodos de pago prestación N° {Number(props.source.data.IdPrestacion).toString()}
    </span>
    <DataGrid
      className="simpleHeader cursor-disabled"
      showBorders={false}
      showColumnLines={false}
      renderAsync
      showRowLines={false}
      dataSource={props.source.data.PeriodoPagos}
      onContentReady={(e) => {
        if (e.component.totalCount() === 0) {
          const config = {};
          config.addClass = "table-margin";
          const noDataSpan = e.component.element().querySelector(".dx-scrollable-wrapper");
          ReactDOM.render(<NoDataComponent config={config} message="Sin Prestaciones económicas" />, noDataSpan);
        }
      }}
    >
      <Column
        dataField="FechaDesde"
        caption="Fecha desde"
        type="date"
        dataType="date"
        format="dd/MM/yyyy"
      />
      <Column
        dataField="FechaHasta"
        caption="Fecha hasta"
        dataType="date"
        format="dd/MM/yyyy"
      />
      <Column dataField="DiasPagados" caption="Dias pagados" />
      <Column
        dataField="FechaPago"
        caption="Fecha de pago"
        dataType="date"
        format="dd/MM/yyyy"
      />
      <Column
        dataField="Monto"
        caption="Monto"
        cellComponent={(row) => (
          <div>
            {`$ ${new Intl.NumberFormat(props.locale).format(row.data.Monto)}`}
          </div>
        )}
      />
      <Column
        dataField="EstadoPago"
        calculateDisplayValue={(data) => data.EstadoPago || "S/D"}
        caption="Estado de pago"
        allowFiltering
        headerFilter={{
          dataSource: [
            { text: "Pendiente", value: "Pendiente" },
            { text: "Pagado", value: "Pagado" },
          ],
        }}
      />
      <Column
        dataField="FormaPago"
        caption="Forma de pago"
        format="currency"
        alignment="right"
        dataType="number"
      />
      <Paging
        defaultPageSize={10}
      />
    </DataGrid>
  </div>
);
const ActionButton = (props) => (
  <Button
    type={props.type}
    disabled={props.disabled}
    text={props.text}
    onClick={props.onClick}
    style={props.style}
    render={(btn) => (
      <div
        style={{
          padding: "7px 0px 0px 0px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

        }}
      >{btn.text}
      </div>
    )}
  />
);

const columnToFilter = [
  { column: "TipoPrestacion", name: "Tipo" },
  { column: "EstadoDocumentacion", name: "Estado documentación" },
  { column: "EstadoPago", name: "Estado de pago" },
  { column: "MontoUltimoPago", name: "Último monto pagado", type: filterType.number },
  {
    column: "FechaUltimoPago",
    name: "Fecha último pago",
    type: filterType.date,
    max: new Date(),
  },
];

class TablePrestacionesEconomicas extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      locale: navigator.language !== "es-CL" ? "es-CL" : navigator.language,
      filtersLoaded: false,
    };
    this.tableRef = React.createRef();
    this.dataSource = new DataSource({
      load: async (options) => {
        try {
          let data = this.props.listaPrestaciones || [];
          let totalCount = (this.props.listaPrestaciones != null && this.props.listaPrestaciones.length) || 0;
          if (!this.state.filtersLoaded) {
            const request = await getPrestacionesApi(this.props.userData.RUT, options.skip, options.skip + options.take, options.filter);
            if (request.status === 200) {
              const result = await request.json();
              const filters = getFiltros(columnToFilter, result.PrestacionesEconomicas);
              this.props.dispatch(setPrestaciones(result.PrestacionesEconomicas, filters));
              this.setState({ filtersLoaded: true });

              data = result.PrestacionesEconomicas || [];
              totalCount = data.length;
            }
          }

          if (options.filter && options.filter.length > 0) {
            const newData = filterData(this.props.listaPrestaciones, options.filter);
            return {
              data: newData,
              totalCount: newData.length,
            };
          }

          return {
            totalCount,
            data,
          };
        } catch (e) {
          this.props.dispatch(openCloseToast({
            isToastOpen: true,
            msgToast: "Error al obtener la lista de prestaciones",
            typeStyle: "error",
            displayTime: 5000
          }));

          return {
            totalCount: 0,
            data: [],
          };
        }
      },
    });
  }

  handleDctos = (row) => {
    const { IdPrestacion } = row.data;
    this.props.dispatch(doGetDocumentBySiniestro(IdPrestacion, row.data, "worker"));
  }

  handleFilterChange = (text, filters) => {
    const currentFilters = [...filters];
    if (text) {
      currentFilters.push({ column: "IdSiniestro", value: { text, value: text }, type: filterType.search });
      currentFilters.push({ column: "IdPrestacion", value: { text, value: text }, type: filterType.search });
    }
    this.tableRef.filter(currentFilters);
    this.tableRef.searchByText(text);
  }

  handleRowClick = (e) => {
    if (this.props.isLoading) return;
    if (e.handled) {
      if (e.isExpanded) {
        e.component.collapseAll(-1);
        e.component.expandRow(e.key);
      } else {
        e.component.collapseRow(e.key);
      }
    } else if (!e.isExpanded) {
      e.component.collapseAll(-1);
      e.component.expandRow(e.key);
    } else {
      e.component.collapseRow(e.key);
    }
  }

  render() {
    return (
      <React.Fragment>
        <TableFilter
          placeholder="Buscar prestaciones por ID siniestro, ID prestación"
          onChange={this.handleFilterChange}
          filters={this.props.filtros}
          show
          buttons={
            {
              filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
              document: null,
              download: { buttonName: "iconDownload", visible: false, buttonAction: null },
              newItem: { buttonName: "custom", visible: false, buttonAction: null },

            }
          }

        />

        <DataGrid
          dataSource={this.dataSource}
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
          className="custom-table"
          noDataText=""
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-scrollable-wrapper");
              ReactDOM.render(<NoDataComponent config={config} message="Sin Prestaciones" />, noDataSpan);
            }
          }}
          rowAlternationEnabled
          hoverStateEnabled
          selection={{
            mode: "single",
          }}
          onRowClick={this.handleRowClick}
          loadPanel={{
            enabled: true,
            showPane: true,
            showIndicator: true,
            indicatorSrc: LoadingGif,
            text: "Cargando...",
          }}
        >
          <MasterDetail
            enabled
            template={(container, options) => ReactDOM.render(<TableDetails source={options} locale={this.state.locale} />, container)}
          />

          <Column
            dataField={["IdSiniestro"]}
            caption="Siniestro"
            allowFiltering
            allowSearch={false}
            cellComponent={(row) =>
              (
                <div className="group-Column" id={`idp_${row.data.IdPrestacion}`}>
                  <div className="dotIcon"><EmptyIcon size={15} border={12} full={row.data.Reposo} />
                    <div className="text space-text"> Trabajo </div>
                  </div>
                  <div className="text space-text"> {row.data.IdSiniestro} </div>

                  <Tooltip
                    contentRender={() => (
                      <div>
                        {`El siniestro ${row.data.Reposo ? "" : "No"} cuenta con un reposo activo`}
                      </div>
                    )}
                    position="top"
                    target={`#idp_${row.data.IdPrestacion}`}
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                  />

                </div>

              )

            }

          />

          <Column

            dataField={["IdPrestacion, TipoPrestacion"]}
            caption="Prestación"
            allowFiltering
            headerFilter={{
              dataSource: [
                { text: "Subsidio", value: "Subsidio" },
                { text: "Indemnización", value: "Indemnización" },
              ],
            }}
            cellComponent={(row) =>
              (
                <div className="group-Column-Prestaciones">
                  <div className={row.data.TipoPrestacion === "Subsidio Directo" ? "table-label-light-blue" : "table-label-green"}>
                    {row.data.TipoPrestacion}
                  </div>
                  <div className="text spaceText" >{Number(row.data.IdPrestacion).toString()}</div>
                </div>
              )

            }
          />

          <Column
            dataField="EstadoDocumentacion"
            caption="Estado documentación"
            calculateDisplayValue={(data) => data.EstadoDocumentacion || "S/D"}
            allowFiltering
            alignment="center"
            headerFilter={{
              dataSource: [
                { text: "Incompleto", value: "Incompleto" },
                { text: "Completo", value: "Completo" },
              ],
            }}

          />
          <Column
            dataField="MontoUltimoPago"
            caption="Último monto pagado"
            allowFiltering={false}
            alignment="left"
            dataType="number"
            cellComponent={(row) => (
              <div>
                {`$ ${new Intl.NumberFormat(this.state.locale).format(row.data.MontoUltimoPago)}`}
              </div>
            )}
            headerCellTemplate={(element, row) => ReactDOM.render(<HeaderTooltip
              id="tooltipMontoPrestaciones"
              textFirst
              widthprops={250}
              headerText="Último monto pagado"
              toolTipText="Valor del último monto pagado de la prestación económica"
            />, element)}
          />

          <Column
            dataField="FechaUltimoPago"
            caption="Fecha último pago"
            calculateDisplayValue={(data) => data.FechaUltimoPago || "S/D"}
            alignment="center"
            dataType="date"
            format="dd/MM/yyyy"
          />
          <Column
            caption="Liquidación de pago"
            alignment="center"
            cellComponent={(row) => (
              <div>
                <ActionButton
                  text="Ver"
                  type="success"
                  onClick={() => this.handleDctos(row)}
                />
              </div>
            )}
          />

          <RemoteOperations
            filtering
            paging={false}
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />

          <Paging
            defaultPageSize={12}
          />

          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />
        </DataGrid>
        <Documentos />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.global.userData,
  listaPrestaciones: state.prestaciones.listaPrestaciones,
  isLoading: state.prestaciones.isLoading || state.documentos.isLoading,
  filtros: state.prestaciones.filtros,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TablePrestacionesEconomicas);
